import { FormFieldDisabledGroup } from '@components/core-ui/form-elements/FormFieldDisabledGroup';
import { IconButtonClean } from '@components/core-ui/form-elements/buttons/IconButton/variations/IconButtonClean';
import SideArrow from '@components/icons/SideArrow.svg';
import { useState } from 'react';
import { colourSet } from './helpers/colourSet';
import { TProps } from './types/TProps';

const colourSwatchClassName =
  'm-[5px] h-5 w-5 shrink-0 cursor-pointer rounded-full border border-transparent outline-offset-2';

const colourPickerRowClassName = 'flex h-[30px] items-center';

const colourPickerIconEnabledClassName =
  '!text-[var(--color-form-field-icon,var(--color-text-muted))] enabled:hover:!text-[var(--color-form-field-icon,var(--color-text-muted))]';

const colourPickerIconDisabledClassName = '!text-[var(--color-form-field-disabled-icon)]';

export const ColourPicker = ({ colours = colourSet, colour, setColour, disabled }: TProps) => {
  const [showPicker, setShowPicker] = useState(false);

  const handlePickColour = (c: string) => {
    setColour(c);
    setShowPicker(false);
  };

  const openPicker = () => {
    if (disabled) {
      setShowPicker(false);
      return;
    }
    setShowPicker(true);
  };

  return (
    <FormFieldDisabledGroup
      disabled={disabled}
      className={['colours w-full', !showPicker ? 'h-[30px]' : ''].filter(Boolean).join(' ')}
    >
      {!showPicker ? (
        <div className={colourPickerRowClassName}>
          <div
            className={[colourSwatchClassName, 'm-0'].join(' ')}
            style={{ backgroundColor: colour }}
            onClick={openPicker}
          />
          <IconButtonClean
            type="button"
            title="More colors"
            className={[
              'flex items-center justify-center',
              disabled ? colourPickerIconDisabledClassName : colourPickerIconEnabledClassName,
            ].join(' ')}
            onClick={openPicker}
          >
            <SideArrow />
          </IconButtonClean>
        </div>
      ) : null}
      {showPicker ? (
        <div className={`${colourPickerRowClassName} flex-wrap`}>
          {colours.map((c) => (
            <div
              key={c}
              className={colourSwatchClassName}
              style={{
                backgroundColor: c,
                outline: c === colour ? '4px solid var(--color-surface-modal)' : 'none',
              }}
              onClick={() => handlePickColour(c)}
            />
          ))}
        </div>
      ) : null}
    </FormFieldDisabledGroup>
  );
};
